import { createContext, useMemo, useState } from 'react'
import {
  ZendeskProviderContextProps,
  ZendeskProviderProps,
} from './ZendeskProvider.types'

export const ZendeskProviderContext =
  createContext<ZendeskProviderContextProps>({})

export const ZendeskProvider = ({ children }: ZendeskProviderProps) => {
  const [zendeskChatIframe, setZendeskChatIframe] =
    useState<HTMLIFrameElement | null>(null)
  const [zendeskLauncherButton, setZendeskLauncherButton] =
    useState<HTMLButtonElement | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [zendeskLauncherHeight, setZendeskLauncherHeight] = useState(0)
  const [zendeskBottomOffset, setZendeskBottomOffset] = useState<number>(0)

  const value = useMemo(() => {
    return {
      zendeskChatIframe,
      setZendeskChatIframe,
      zendeskLauncherButton,
      setZendeskLauncherButton,
      isOpen,
      setIsOpen,
      zendeskBottomOffset,
      setZendeskBottomOffset,
      zendeskLauncherHeight,
      setZendeskLauncherHeight,
    }
  }, [
    zendeskChatIframe,
    setZendeskChatIframe,
    zendeskLauncherButton,
    setZendeskLauncherButton,
    isOpen,
    setIsOpen,
    zendeskBottomOffset,
    setZendeskBottomOffset,
    zendeskLauncherHeight,
    setZendeskLauncherHeight,
  ])

  return (
    <ZendeskProviderContext.Provider value={value}>
      {children}
    </ZendeskProviderContext.Provider>
  )
}
